import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "carouselExampleCaptions",
  class: "carousel slide",
  "data-bs-ride": "false",
  dir: "rtl"
}
const _hoisted_2 = { class: "carousel-indicators" }
const _hoisted_3 = {
  key: 0,
  type: "button",
  "data-bs-target": "#carouselExampleCaptions",
  "data-bs-slide-to": "0",
  class: "active",
  "aria-current": "true",
  "aria-label": "Slide 1"
}
const _hoisted_4 = {
  key: 1,
  type: "button",
  "data-bs-target": "#carouselExampleCaptions",
  "data-bs-slide-to": "1",
  "aria-label": "Slide 2"
}
const _hoisted_5 = {
  key: 2,
  type: "button",
  "data-bs-target": "#carouselExampleCaptions",
  "data-bs-slide-to": "2",
  "aria-label": "Slide 3"
}
const _hoisted_6 = {
  key: 3,
  type: "button",
  "data-bs-target": "#carouselExampleCaptions",
  "data-bs-slide-to": "3",
  "aria-label": "Slide 4"
}
const _hoisted_7 = {
  key: 4,
  type: "button",
  "data-bs-target": "#carouselExampleCaptions",
  "data-bs-slide-to": "4",
  "aria-label": "Slide 5"
}
const _hoisted_8 = {
  class: "carousel-inner w-100",
  "data-aos": "zoom-in"
}
const _hoisted_9 = { class: "carousel-caption d-flex px-4 px-md-0" }
const _hoisted_10 = { class: "font-weight-bold mb-4 text-color4" }
const _hoisted_11 = { class: "carousel-caption d-flex px-4 px-md-0" }
const _hoisted_12 = { class: "font-weight-bold mb-4 text-color4" }
const _hoisted_13 = { class: "carousel-caption d-flex px-4 px-md-0" }
const _hoisted_14 = { class: "font-weight-bold mb-4 text-color4" }
const _hoisted_15 = { class: "carousel-caption d-flex px-4 px-md-0" }
const _hoisted_16 = { class: "font-weight-bold mb-4 text-color4" }
const _hoisted_17 = { class: "carousel-caption d-flex px-4 px-md-0" }
const _hoisted_18 = { class: "font-weight-bold mb-4 text-color4" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselExampleCaptions\" data-bs-slide=\"prev\"><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselExampleCaptions\" data-bs-slide=\"next\"><span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Next</span></button>", 2)

import { ref, onMounted } from 'vue';
import { useConfigStore, useGlobalStore } from '@/stores';
import { SliderType } from '@/composables/types';

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'HomePageSlider',
  setup(__props) {

const configStore = useConfigStore();
const globalStore = useGlobalStore();

const sliders = ref<SliderType[] | undefined>(undefined);

onMounted(() => {
  if (globalStore.sliders.length <= 0) {
    globalStore.fetchSliders(undefined);
  }
  sliders.value = globalStore.sliders;
});

return (_ctx: any,_cache: any) => {
  return (sliders.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (sliders.value[0])
            ? (_openBlock(), _createElementBlock("button", _hoisted_3))
            : _createCommentVNode("", true),
          (sliders.value[1])
            ? (_openBlock(), _createElementBlock("button", _hoisted_4))
            : _createCommentVNode("", true),
          (sliders.value[2])
            ? (_openBlock(), _createElementBlock("button", _hoisted_5))
            : _createCommentVNode("", true),
          (sliders.value[3])
            ? (_openBlock(), _createElementBlock("button", _hoisted_6))
            : _createCommentVNode("", true),
          (sliders.value[4])
            ? (_openBlock(), _createElementBlock("button", _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (sliders.value[0])
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "carousel-item w-100 h-100 active",
                style: _normalizeStyle(`background-image: url(${sliders.value[0].background})`)
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(configStore).stringLang(sliders.value[0].titleAr, sliders.value[0].titleEn)), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(configStore).stringLang(
                  sliders.value[0].subtitleAr,
                  sliders.value[0].subtitleEn
                )), 1)
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (sliders.value[1])
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "carousel-item w-100 h-100",
                style: _normalizeStyle(`background-image: url(${sliders.value[1].background})`)
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_12, _toDisplayString(_unref(configStore).stringLang(sliders.value[1].titleAr, sliders.value[1].titleEn)), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(configStore).stringLang(
                  sliders.value[1].subtitleAr,
                  sliders.value[1].subtitleEn
                )), 1)
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (sliders.value[2])
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "carousel-item w-100 h-100",
                style: _normalizeStyle(`background-image: url(${sliders.value[2].background})`)
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_14, _toDisplayString(_unref(configStore).stringLang(sliders.value[2].titleAr, sliders.value[2].titleEn)), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(configStore).stringLang(
                  sliders.value[2].subtitleAr,
                  sliders.value[2].subtitleEn
                )), 1)
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (sliders.value[3])
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "carousel-item w-100 h-100",
                style: _normalizeStyle(`background-image: url(${sliders.value[3].background})`)
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_16, _toDisplayString(_unref(configStore).stringLang(sliders.value[3].titleAr, sliders.value[3].titleEn)), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(configStore).stringLang(
                  sliders.value[3].subtitleAr,
                  sliders.value[3].subtitleEn
                )), 1)
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (sliders.value[4])
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "carousel-item w-100 h-100",
                style: _normalizeStyle(`background-image: url(${sliders.value[4].background})`)
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_18, _toDisplayString(_unref(configStore).stringLang(sliders.value[4].titleAr, sliders.value[4].titleEn)), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(configStore).stringLang(
                  sliders.value[4].subtitleAr,
                  sliders.value[4].subtitleEn
                )), 1)
                  ])
                ])
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _hoisted_19
      ]))
    : _createCommentVNode("", true)
}
}

})